import { createReducer, on } from '@ngrx/store';
import { LineType } from 'src/app/core';

import {
  actionBrandLineConfigGet,
  actionBrandLineConfigGetSuccess,
} from './configs.actions';

export interface ConfigsState {
  values: { [key: string]: LineType };
  isAllDefaultValues: boolean;
  isLoadingBrandLineConfig?: boolean;
}

const initialState: ConfigsState = {
  values: undefined,
  isAllDefaultValues: false,
  isLoadingBrandLineConfig: true,
};

export const configsReducer = createReducer(
  initialState,
  on(actionBrandLineConfigGet, (state) => {
    return {
      ...state,
      isLoadingBrandLineConfig: true,
    };
  }),
  on(actionBrandLineConfigGetSuccess, (state, action) => {
    return {
      ...state,
      values: action.response.values,
      isAllDefaultValues: action.response.isAllDefaultValues,
      isLoadingBrandLineConfig: false,
    };
  }),
);
